import React from 'react';
import { Button } from '../../../components/ui/Button/Button';
import { Card } from '../../../components/ui/Card/Card';
import { StatusPill } from '../../../components/ui/StatusPill/StatusPill';
import type { Ticket } from '../../../types/support';
import styles from './MyTicketsCard.module.scss';

interface MyTicketsCardProps {
  tickets: Ticket[];
  onOpen: (id: string) => void;
  onOpenAll: () => void;
}

export function MyTicketsCard({ tickets, onOpen, onOpenAll }: MyTicketsCardProps) {
  return (
    <Card title="Мои обращения" icon="doc" action={<Button onClick={onOpenAll}>Все</Button>}>
      {tickets.length === 0 ? (
        <p className={styles.empty}>Обращений пока нет</p>
      ) : (
        tickets.map((ticket) => (
          <button
            key={ticket.number}
            type="button"
            className={styles.ticket}
            onClick={() => onOpen(ticket.number)}
            aria-label={`Открыть обращение ${ticket.number}`}
          >
            <div className={styles.copy}>
              <div className={styles.number}>{ticket.number}</div>
              <span className={styles.title}>{ticket.title}</span>
              <span className={styles.date}>{ticket.date}</span>
            </div>
            <StatusPill status={ticket.status} compact>
              {ticket.statusLabel}
            </StatusPill>
          </button>
        ))
      )}
    </Card>
  );
}